import SBPLogoGenbank from './SBPLogoGenbank';

export default SBPLogoGenbank;
